import dayjs from 'dayjs'
import type { FieldValues } from 'react-hook-form'
import { Controller } from 'react-hook-form'

import { TextField } from '@mui/material'

import type { ControlledFieldBaseProps } from './types'

/**
 * Native `type="date"` MUI field bound to a react-hook-form `Controller`.
 * Accepts a `Date` (or ISO string) value and emits a `Date` on change.
 */
export function ControlledDateField<T extends FieldValues>({ name, label, control }: ControlledFieldBaseProps<T>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const rawValue = field.value as unknown
        const stringValue = rawValue instanceof Date ? dayjs(rawValue).format('YYYY-MM-DD') : ((rawValue as string | undefined) ?? '')
        return (
          <TextField
            id={name}
            name={field.name}
            inputRef={field.ref}
            label={label}
            type="date"
            fullWidth
            value={stringValue}
            onBlur={field.onBlur}
            onChange={(event) => field.onChange(event.target.value ? new Date(event.target.value) : undefined)}
            InputLabelProps={{ shrink: true }}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
          />
        )
      }}
    />
  )
}
